import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RegistroHorasService } from '../../../services/employees/registro-horas.service';

@Component({
    selector: 'app-tiempo-form',
    templateUrl: './tiempo-form.component.html',
    styleUrls: ['./tiempo-form.component.css'],
    standalone: false
})
export class TiempoFormComponent implements OnInit {
  form: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<TiempoFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private registroHorasService: RegistroHorasService
  ) { }

  ngOnInit() {
    this.inicializarFormulario();
  }

  // #region Métodos del componente

  cancelar(): void {
    this.dialogRef.close();
  }

  guardar(): void {
    if (this.form.valid) {
      const request = {
        motivo: this.form.get('motivo').value
      };

      this.registroHorasService.iniciarPausa(this.data.registroHorasId, request)
        .subscribe(
          (resultado) => {
            if (resultado) {
              this.dialogRef.close(true);
            }
          }
        );
    }
  }

  // #endregion

  // #region Métodos privados

  private inicializarFormulario(): void {
    this.form = new UntypedFormGroup({
      motivo: new UntypedFormControl('', [Validators.required])
    });
  }

  // #endregion
} 